import LineItemToValidate from '@/common/components/LineItemToValidate/LineItemToValidate'
import { lineItemStatuses } from '@/parcels/constants'

import LocationDetail from '../LocationDetail/LocationDetail'
import * as Styles from './styles'

const ItemsToValidate = ({ lineItems, onChangeItemStatus }) => {
  return (
    <>
      {lineItems?.map(item => (
        <Styles.ItemContainer key={item.id}>
          <LocationDetail
            locationDetails={item?.location_details}
            availableQuantity={item?.variant?.available_quantity}
          />
          <LineItemToValidate
            lineItem={item}
            options={{
              showForReviewButton: false,
              statusForAccepted: lineItemStatuses.packed,
              statusForRejected: lineItemStatuses.discarded,
              showActions: item.status !== lineItemStatuses.packed,
              acceptLabel: 'Empaquetar',
              rejectLabel: 'Descartar',
            }}
            onChangeStatus={onChangeItemStatus}
          />
        </Styles.ItemContainer>
      ))}
    </>
  )
}

export default ItemsToValidate
